import React, { useCallback, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames/bind';
import { useTranslation } from '@planity/localization';
import { Button, useModal } from '@planity/ui';
import { Localize } from '@planity/components';
import styles from './payment_warning_modal.scss';

const paymentType = {
	klarna: 'Klarna',
	giropay: 'Giropay',
	bancontact: 'Bancontact'
};

export const PaymentWarningModal = ({ paymentMethodType, onClick }) => {
	useStyles(styles);
	const { t } = useTranslation();
	const classes = classNames.bind(styles)({
		paymentWarningModal: true
	});
	const { closeModal } = useModal();
	const [isLoading, setIsLoading] = useState(false);

	const onModalClick = useCallback(async () => {
		if (onClick) {
			setIsLoading(true);
			try {
				await onClick();
			} finally {
				setIsLoading(false);
			}
		}
		closeModal();
	}, [onClick, closeModal]);

	return (
		<div className={classes}>
			<div className={styles.title}>{paymentType[paymentMethodType]}</div>
			<div className={styles.message}>
				{process.env.WEBVIEW ? (
					<Localize
						args={{ paymentType: paymentType[paymentMethodType] }}
						text={'message.exotic.payments.app'}
					/>
				) : process.env.WIDGET ? (
					<Localize
						args={{ paymentType: paymentType[paymentMethodType] }}
						text={'message.exotic.payments.whiteLabel'}
					/>
				) : (
					<Localize
						args={{ paymentType: paymentType[paymentMethodType] }}
						text={'message.exotic.payments.planity'}
					/>
				)}
			</div>
			<div>
				<Button
					id={'payment-warning-dismiss-button'}
					isFullMobile
					isFullWidth
					isLoading={isLoading}
					label={t('myAccount.iUnderstood')}
					onClick={onModalClick}
				/>
			</div>
		</div>
	);
};
